import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

import { Const } from '../const';

import { environment } from '../../environments/environment';

import { AppMonitorServiceProvider } from '../servicer/app-monitor-service';
import { AppMonitorResponse } from '../servicer/models/app-monitor-response';

/**
 * alertsを定期間隔で取得するプロバイダー.
 */
@Injectable()
export class AppMonitorIntervalReceiverProvider {
  /** 空のレスポンス. */
  private readonly appMonitorEmptyResponse = null;

  /** alerts情報. */
  public appMonitorInfos$: BehaviorSubject<AppMonitorResponse> = new BehaviorSubject<AppMonitorResponse>(this.appMonitorEmptyResponse);

  /** インターバルのSubscription. */
  private intervalSubscription: Subscription = null;

  /** 実行中. */
  private processing = false;

  constructor(
    public appMonitorService: AppMonitorServiceProvider
  ) { }

  /**
   * 開始.
   */
  start() {
    this.get().subscribe(() => {
      this.intervalSubscription = Observable.interval(environment.appMonitorInterval)
        .subscribe(() => this.execute());
    });
  }

  /**
   * 実行します.
   */
  execute() {
    of(this.processing)
      .filter((processing) => !processing)
      .pipe(tap(() => this.processing = true))
      .flatMap(() => this.get())
      .pipe(tap(() => this.processing = false))
      .subscribe();
  }

  /**
   * 停止.
   */
  stop() {
    this.appMonitorInfos$.next(this.appMonitorEmptyResponse);

    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = null;
    }
  }

  /**
   * alerts表示情報を取得します.
   * 定期的に呼び出されるため、エラーが発生しても、何も処理をしません.
   */
  private get(): Observable<AppMonitorResponse> {
    return this.appMonitorService.get()
      .map((response) => {
        if (response.result === Const.ResponseResult.SUCCESS) {
          this.appMonitorInfos$.next(response);
        }

        return this.appMonitorInfos$.value;
      })
      .catch((error) => {
        console.error(error);
        return Observable.of(this.appMonitorInfos$.value);
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/app-monitor-interval-receiver/app-monitor-interval-receiver.ts